export const STORAGE_KEY = {
  ANCILLARY_QUOTE_DATA: 'ancillaryQuoteData',
  VISION_PLAN_SELECTED: 'visionPlanSelected',
  DENTAL_PLAN_SELECTED: 'dentalPlanSelected',
  VISION_PLAN_ID: 'visionPlanId',
  DENTAL_PLAN_ID: 'dentalPlanId',
} as const

export type STORAGE_KEY = (typeof STORAGE_KEY)[keyof typeof STORAGE_KEY]
